import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const ChargeTypeParamsSchema = object({
  chargeTypeId: stringToNumber()
})
